<div class="p-d-flex p-flex-column">
  <div class="p-d-flex p-flex-column p-jc-center">
    <div class="step-subtitle">Korak 1</div>
    <div class="step-title">Odabir paketa</div>
  </div>
  <kodit-odabir-paketa-form></kodit-odabir-paketa-form>
</div>
